//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Media = createAsyncThunk(
  "Media",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingMedia(""));
      const response = await UsePortalApi(
        `Patient/Media`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingMediaSuccess(response[0].entry)) : dispatch(gettingMediaClear())

      } else {
        dispatch(
          gettingMediaFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingMediaFailed(error));
    }
  }
);
const MediaSlice = createSlice({
  name: "Media",
  initialState: {
    Resources: null,
    isGetting: false,
    error: false,
  },
  reducers: {
    gettingMedia: (state, action) => {
      state.Resources = null;
      state.isGetting = true;
      state.error = false;
    },
    gettingMediaSuccess: (state, action) => {
      state.Resources = action.payload;
      state.isGetting = false;
      state.error = false;
    },
    gettingMediaFailed: (state, action) => {
      state.Resources = null;
      state.isGetting = false;
      state.error = true;
    },
    gettingMediaClear: (state, action) => {
      state.Resources = null;
      state.isGetting = false;
      state.error = false;
    },
  },
});
export const {
  gettingMedia,
  gettingMediaSuccess,
  gettingMediaFailed,
  gettingMediaClear,
} = MediaSlice.actions;
export default MediaSlice.reducer;
